"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth0GrantType = exports.Operation = exports.CredentialType = exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["Production"] = "https://authex.fi.cimpress.io";
    Environment["Integration"] = "https://int-authex.fi.cimpress.io";
})(Environment = exports.Environment || (exports.Environment = {}));
var CredentialType;
(function (CredentialType) {
    CredentialType["Basic"] = "basic";
    CredentialType["Auth0"] = "auth0";
    CredentialType["CustomAuth0"] = "customAuth0";
    CredentialType["Token"] = "token";
    CredentialType["SshCertificate"] = "sshCertificate";
})(CredentialType = exports.CredentialType || (exports.CredentialType = {}));
var Operation;
(function (Operation) {
    Operation["Order"] = "order";
    Operation["Cancellation"] = "cancellation";
    Operation["ChangeRequest"] = "changeRequest";
})(Operation = exports.Operation || (exports.Operation = {}));
var Auth0GrantType;
(function (Auth0GrantType) {
    Auth0GrantType["ClientCredentials"] = "clientCredentials";
    Auth0GrantType["Password"] = "password";
    Auth0GrantType["LegacyPassword"] = "legacyPassword";
})(Auth0GrantType = exports.Auth0GrantType || (exports.Auth0GrantType = {}));
